import _ from 'lodash';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './Lyrics.module.scss';
import classNames from 'classnames';
import roundRegistry from '../roundRegistry';
import posed from 'react-pose';
import {keysToSingleValue} from '../utils/objectFactory';
import {allPoses, lyricsPoses, getStableRound} from '../gameHelpers';

const Container = posed.div({
    ...keysToSingleValue(lyricsPoses, {
        x: '20em',
        transition: {
            ease: 'easeOut',
            duration: 1000,
        },
    }),
    ...keysToSingleValue(_.difference(allPoses, lyricsPoses), {
        x: '100vw',
        delay: 0,
        transition: {
            ease: 'easeIn',
            duration: 1000,
        },
    }),
});

export default class Lyrics extends Component {
    static propTypes = {
        game: PropTypes.object.isRequired,
    };

    render() {
        const {game} = this.props;
        const round = getStableRound(game);
        const {songName, lyrics} = roundRegistry[round];

        const lyricsLines = lyrics
            .trim()
            .split(/\n/)
            .map(s => s.trim());

        return (
            <Container className={styles.container}>
                <div className={styles.header}>
                    <div className={styles.songName}>{songName}</div>
                    <div className={styles.line} />
                </div>
                <div className={styles.lyrics}>
                    {lyricsLines.map((line, index) => (
                        <div key={index} className={styles.lyricsLine}>
                            {line}
                        </div>
                    ))}
                </div>
            </Container>
        );
    }
}
